import React from 'react'
import { MainLayout } from './MainLayout'
import { GalleryFilter } from '../GalleryFilter'
import { useIsMobile } from '../../actions/ui'

export const GalleryLayout = ({
  children,
  activeTab,
  onStartingLocationSearch
}) => {
  const isMobile = useIsMobile()
  return (
    <MainLayout activeTab={ activeTab }>
      { isMobile && <GalleryFilter onStartingLocationSearch={ onStartingLocationSearch }/> }
      { children }
    </MainLayout>
  )
}